import './DropdownModal.scss'
const DropdownModal = props=>{
    return (
        <div className={`dropdown-container ${props.className}`} onClick={(e)=>{
            e.stopPropagation();
        }}>
            {props.children}
        </div>
    )
}

export default DropdownModal;